module.exports = __webpack_public_path__ + "static/media/emailExcel.264b745e.svg";